import AdBanner from 'components/commons/AdBanner';
import Toast from 'components/commons/Toast';
import { COLOR_BACKGROUND } from 'constants/color';
import { vw } from 'constants/size';
import React from 'react';
import { StyleSheet, View } from 'react-native';

type Props = {
	headerChildren: React.ReactNode;
	mainChildren: React.ReactNode;
	footerChildren: React.ReactNode;
};

const styles = StyleSheet.create({
	container: {
		flex: 1,
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: COLOR_BACKGROUND,
	},
	header: {
		flexShrink: 0,
		width: vw,
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: 4,
	},
	main: {
		flexGrow: 1,
	},
	footer: {
		flexShrink: 0,
		width: vw,
	},
});

const BaseLayout: React.FC<Props> = ({
	headerChildren,
	mainChildren,
	footerChildren,
}) => {
	return (
		<View style={styles.container}>
			<View style={styles.header}>{headerChildren}</View>
			<View style={styles.main}>{mainChildren}</View>
			<View style={styles.footer}>
				{footerChildren}
				<Toast />
				<AdBanner />
			</View>
		</View>
	);
};

export default BaseLayout;
